var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fragment',[_c('v-chip',{staticClass:"mr-1",attrs:{"outlined":"","label":""}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("place")]),_vm._v(" Geography: "+_vm._s(_vm.value.geography)+" ")],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }